import "arrive";
import $ from "jquery";

document.arrive(".search-bar", { existing: true }, function () {

    // Lenis helpers
    const getLenis = () => {
        if (window.lenis) return window.lenis;
        if (window.Lenis && window.Lenis.instance) return window.Lenis.instance;
        return null;
    };
    const stopLenis = () => { const l = getLenis(); if (l && typeof l.stop === 'function') l.stop(); };
    const startLenis = () => { const l = getLenis(); if (l && typeof l.start === 'function') l.start(); };

    $('.search-init').on('click', function(e) {
        e.preventDefault();



        const $bar = $('#search-bar');

        // Toggle della barra di ricerca
        if ($bar.hasClass('hidden')) {
            $bar.fadeIn(250).removeClass('hidden');
            $('#ajax-search-input').focus();
            stopLenis();
        } else {
            $bar.fadeOut(200, function() {
                $bar.addClass('hidden');
                startLenis();
            });
        }

        // Se siamo dentro un offcanvas (mobile), chiudi il menu
        const $offcanvasClose = $(this).closest('.offcanvas').find('.btn-close');
        if ($offcanvasClose.length) {
            $offcanvasClose.trigger('click');
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === "Escape") {
            $('#search-bar').fadeOut(200, function(){ startLenis(); });
            $('#ajax-search-results').hide();
        }
    });

    let typingTimer;
    let lastLength = 0;
    // Id della richiesta in corso per ignorare risposte obsolete
    let requestId = 0;

    $('#ajax-search-input').on('input', function() {
        let searchTerm = $(this).val().trim();
        let $bar       = $('#search-bar');
        let ajaxUrl    = $bar.data('ajax-url');
        let nonce      = $bar.data('nonce');
        let lang       = $bar.data('lang'); // lingua corrente (es. 'it'|'en')
        let $results   = $('#ajax-search-results');

        // 🔹 Messaggi traducibili via data-attribute
        const msgLoading = $bar.data('msg-loading');
        const msgNoResults = $bar.data('msg-noresults');
        const msgError = $bar.data('msg-error');
        const msgTooShort = $bar.data('msg-tooshort');

        clearTimeout(typingTimer);

        if (searchTerm.length === 0) {
            // Input svuotato: nascondi e cancella risultati, annulla eventuale debounce
            $results.hide().empty();
            clearTimeout(typingTimer);
            // incrementa requestId così eventuali risposte in arrivo verranno ignorate
            requestId++;
            lastLength = 0;
            return;
        }

        if (searchTerm.length < 3) {
            lastLength = searchTerm.length;
            $results.html(`<div class="search-message too-short">${msgTooShort}</div>`).show();
            return;
        }

        if (searchTerm.length === 3 || searchTerm.length > lastLength) {
            performSearch();
        } else {
            typingTimer = setTimeout(performSearch, 350);
        }

        lastLength = searchTerm.length;

        function performSearch() {
            const currentReq = ++requestId;
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'ste_ajax_search',
                    nonce: nonce,
                    s: searchTerm,
                    lang: lang || ''
                },
                beforeSend: function() {
                    $results.html(`<div class="search-message loading">${msgLoading}</div>`).show();
                },
                success: function(response) {
                    // Se l'input è stato svuotato o questa risposta è obsoleta, ignora
                    if (currentReq !== requestId || $('#ajax-search-input').val().trim().length === 0) {
                        return;
                    }
                    if (response.success && response.data.length > 0) {
                        let html = '<ul>';
                        const arrowSvgUrl = $('#search-bar').data('arrow-svg');
                        response.data.forEach(item => {
                        // Crea l’HTML dell’SVG
                        const svgIcon = arrowSvgUrl ? `<img src="${arrowSvgUrl}" class="result-arrow" alt="">` : '';

                        if (item.type === 'author') {
                            html += `<li class="result-author">
                                        <a href="${item.link}">${item.title} ${svgIcon}</a>
                                    </li>`;
                        } else {
                            html += `<li>
                                        <a href="${item.link}">${item.title} ${svgIcon}</a>
                                    </li>`;
                        }
                    });
                        html += '</ul>';
                        $results.html(html).show();
                    } else {
                        $results.html(`<div class="search-message no-results">${msgNoResults}</div>`).show();
                    }
                },
                error: function() {
                    if (currentReq !== requestId || $('#ajax-search-input').val().trim().length === 0) {
                        return;
                    }
                    $results.html(`<div class="search-message error">${msgError}</div>`).show();
                }
            });
        }

        // Invio da tastiera: previeni submit e lancia l'AJAX
        $('#ajax-search-input').off('keydown.steSearchEnter').on('keydown.steSearchEnter', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                const currentTerm = $(this).val().trim();
                if (currentTerm.length >= 3) {
                    clearTimeout(typingTimer);
                    // aggiorna la variabile locale e cerca
                    searchTerm = currentTerm;
                    performSearch();
                } else {
                    // Se si preme invio con input vuoto o troppo corto: nascondi e annulla
                    $results.hide().empty();
                    requestId++;
                }
                return false;
            }
        });
    });

    const $input = $('#ajax-search-input');
    const $clear = $('#clear-search');

    // Rendi la X sempre visibile all'apertura
    $clear.show();

    // Mostra o nasconde la X custom in base al testo digitato
    $input.on('input', function() {
        // Se vuoi tenerla sempre visibile, puoi non togglarla;
        // in alternativa mantieni il toggle per UX: evidenzia che c'è qualcosa da cancellare
        $clear.toggle($(this).val().length > 0);
    });

    // Click sulla X: se c'è testo pulisce, altrimenti chiude la barra
    $clear.on('click', function() {
        const hasText = $input.val().length > 0;
        if (hasText) {
            // Pulisce il campo e nasconde i risultati, mantiene visibile la X
            $input.val('').focus();
            $('#ajax-search-results').hide().empty();
            // mantieni visibile la X (niente .hide())
            $clear.show();
        } else {
            // Nessun testo: chiudi la barra di ricerca
            const $bar = $('#search-bar');
            $bar.fadeOut(200, function() {
                $bar.addClass('hidden');
                startLenis();
            });
            $('#ajax-search-results').hide().empty();
        }
    });

});
